import * as contentType from '../enums/content-type'

let resolve = (type, resourceTypes) => {
  switch (type) {
    case contentType.ACTIVITY:
      return resourceTypes.activities
    case contentType.LESSON:
      return resourceTypes.lessons
    case contentType.ASSESSMENT:
      return resourceTypes.assessments
    case contentType.TEMPLATE:
      return resourceTypes.templates
    case contentType.CLASSROOM_TOOLS:
      return resourceTypes.teacherTools
  }
}

export default {
  resolve
}
